import { createSearchParams } from "react-router-dom"

import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { MassPayoutsPageView } from "@src/pages/massPayouts/crypto"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { MassPayoutsStepUi } from "@src/widgets/onboarding/ui/tours/MassCrypto/steps/MassPayoutsStepUi"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class MassPayoutsStep extends TourStepBase {
  component = MassPayoutsStepUi
  name = `${ONBOARDING_TOURS.MASS_CRYPTO}_MassPayouts`

  constructor() {
    super({
      highlightElements: ["#GENERATED_ID_MANUALPAYOUTSFORM_FORM_VOID_1"],
      placement: TOUR_MODAL_PLACEMENTS.BOTTOM_RIGHT,
    })
  }

  action() {
    return router.navigate({
      pathname: paths.massPayouts,
      search: `?${createSearchParams({ view: MassPayoutsPageView.UPLOAD })}`,
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      pic: this.name,
      subtitle: "Streamline transaction processes and save time",
      title: "Mass Payouts via .CSV File Upload",
    }
  }
}
